@if (service.isLoadingSpinner === true) {
<div id="spinnerOverlay">
    <app-spinner-overlay></app-spinner-overlay>
</div>
}
<div>
    <div style="width: 100%; display: inline-block;">
        <div style="float: right; margin-left: 10px;">
            <mat-icon class="clickable" (click)="OnClickClose()">close</mat-icon>
        </div>
        <div style="float: right;">
            <i style="font-size: 1.5em;" class="fa fa-file-excel-o clickable text-success" aria-hidden="true" (click)="OnClickExport()" title="Export to Excel"></i>
        </div>
    </div>
</div>
<div style="margin: auto;">
    <div class="scrollable">
        <table #table mat-table [dataSource]="dataSource" matSort matSortActive="Date" matSortDisableClear matSortDirection="desc">

            @for (column of displayColumnsDynamic; track column) {
            <ng-container matColumnDef="{{column}}">
                <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width]="100/displayColumnsDynamic.length + '%'"
                    style=" font-size: 16px; min-width: 125px; height: 25px;">
                    {{column}}
                </th>
                <td mat-cell *matCellDef="let element" [innerHtml]="OnDataBound(column, element)"></td>
            </ng-container>
            }

            @for (column of displayFiltersDynamic; track column; let i = $index) {
            <ng-container matColumnDef="{{column.name + ' Filter'}}">
                <th mat-header-cell *matHeaderCellDef [style.width]="100/displayFiltersDynamic.length + '%'" style="min-width: 125px;" class="tableFilterFont">
                    @if (column.type === 'text') {
                    <mat-form-field>
                        <mat-label>Filter</mat-label>
                        <input matInput #filterText [(ngModel)]="column.filter.filterValue" autocomplete="off" style="width: calc(100% - 35px)" />
                        <button mat-icon-button [ngClass]="{'filterEnabled':column.filter.filterEnabled === true }" (click)="filterCriteria.open()" style="position: absolute; top: 0px">
                            <mat-icon>filter_alt</mat-icon>
                        </button>
                        <div style="width: 0; overflow: hidden; margin: 0">
                            <mat-select #filterCriteria style="max-width: 200px" [(ngModel)]="column.filter.filterType" [ngModelOptions]="{standalone: true}" (openedChange)="ApplyFilterOptions($event, column)">
                                <mat-option value="temp">No Filter</mat-option>
                                <mat-option value="contains">Contains</mat-option>
                                <mat-option value="equals">Equals</mat-option>
                                <mat-option value="greaterThan">Greater Than</mat-option>
                                <mat-option value="lessThan">Less Than</mat-option>
                            </mat-select>
                        </div>
                    </mat-form-field>





                    <!--<div style="width: 100%; display: inline-flex;">
      <input type="text" matInput [(ngModel)]="column.filter.filterValue" style="vertical-align: middle; border: 1px solid; border-radius: 5px; height: 25px; width: 75px; margin: auto;">
      <mat-select class="triggerChange" [(ngModel)]="column.filter.filterType" [ngModelOptions]="{standalone: true}" (openedChange)="ApplyFilterOptions($event, column)">
        <mat-select-trigger class="filterIcon">
          <mat-icon style="vertical-align: middle;" [ngClass]="{'filterEnabled':column.filter.filterEnabled === true }">
            filter_alt
          </mat-icon>
        </mat-select-trigger>
        <mat-option value="temp">No Filter</mat-option>
        <mat-option value="contains">Contains</mat-option>
        <mat-option value="equals">Equals</mat-option>
        <mat-option value="greaterThan">Greater Than</mat-option>
        <mat-option value="lessThan">Less Than</mat-option>
      </mat-select>
    </div>-->
                    }
                    @if (column.type === 'date') {
                    <mat-form-field appearance="fill" class="tableFilterFont" style="width:100%; min-width:125px;">
                        <mat-label>Filter</mat-label>

                        <input matInput [matDatepicker]="picker_i" [(ngModel)]="column.filter.filterValue" [ngModelOptions]="{ standalone: true }" (dateChange)="ApplyFilterOptions(false, column)" />

                        <mat-hint>MM/DD/YYYY</mat-hint>

                        <mat-datepicker-toggle matIconSuffix [for]="picker_i" [ngClass]="{ filterEnabled: column.filter.filterEnabled === true }">
                        </mat-datepicker-toggle>

                        <mat-datepicker #picker_i>
                            <mat-datepicker-actions>
                                <button mat-raised-button color="warn" matDatepickerCancel (click)="ResetDateFilter(column)">
                                    {{ 'btnReset' | translate }}
                                </button>
                                <button mat-raised-button color="primary" matDatepickerApply (click)="ApplyFilterOptions(false, column)">
                                    {{ 'btnApply' | translate }}
                                </button>
                            </mat-datepicker-actions>
                        </mat-datepicker>
                    </mat-form-field>
                    }

                    @if (column.type === 'bool') {
                    <div style="width: 100%; display: inline-flex;">
                        <mat-checkbox [(ngModel)]="column.filter.filterValue" [ngModelOptions]="{standalone: true}" color="primary" (change)="ApplyFilterOptions(false, column)"></mat-checkbox>
                    </div>
                    }
                    @if (column.type === 'number') {
                    <mat-form-field>
                        <mat-label>Filter</mat-label>
                        <input matInput #filterText type="number" [(ngModel)]="column.filter.filterValue" autocomplete="off" style="width: calc(100% - 35px)" />
                        <button mat-icon-button [ngClass]="{'filterEnabled':column.filter.filterEnabled === true }" (click)="filterCriteria.open()" style="position: absolute; top: 0px">
                            <mat-icon>filter_alt</mat-icon>
                        </button>
                        <div style="width: 0; overflow: hidden; margin: 0">
                            <mat-select #filterCriteria style="max-width: 200px" [(ngModel)]="column.filter.filterType" [ngModelOptions]="{standalone: true}" (openedChange)="ApplyFilterOptions($event, column)">
                                <mat-option value="temp">No Filter</mat-option>
                                <mat-option value="equals">Equals</mat-option>
                                <mat-option value="greaterThan">Greater Than</mat-option>
                                <mat-option value="lessThan">Less Than</mat-option>
                            </mat-select>
                        </div>
                    </mat-form-field>




                    <!-- <mat-form-field appearance="fill" class="tableFilterFont" style="width:100%; min-width:125px;">
                        <mat-label>Filter</mat-label>

                        <input matInput type="number" [(ngModel)]="column.filter.filterValue" [ngModelOptions]="{ standalone: true }" (ngModelChange)="ApplyFilterOptions(false, column)" />

                        <mat-select matIconSuffix [(ngModel)]="column.filter.filterType" [ngModelOptions]="{ standalone: true }" (openedChange)="ApplyFilterOptions($event, column)" class="filter-select">
                            <mat-select-trigger>
                                <mat-icon [ngClass]="{ filterEnabled: column.filter.filterEnabled === true }">
                                    filter_alt
                                </mat-icon>
                            </mat-select-trigger>

                            <mat-option value="temp">No Filter</mat-option>
                            <mat-option value="equals">Equals</mat-option>
                            <mat-option value="greaterThan">Greater Than</mat-option>
                            <mat-option value="lessThan">Less Than</mat-option>
                        </mat-select>
                    </mat-form-field> -->
                    }
                </th>
            </ng-container>
            }

            <ng-container matColumnDef="loading">
                <th class="loading" mat-footer-cell *matFooterCellDef [attr.colspan]="displayColumnsDynamic.length">
                    {{'tblLoading' | translate}}...
                </th>
            </ng-container>

            <ng-container matColumnDef="noData">
                <th class="loading" mat-footer-cell *matFooterCellDef [attr.colspan]="displayColumnsDynamic.length">
                    {{
                    'Reports.reportResultsNoData' |
                    translate
                    }}...
                </th>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayColumnsDynamic; sticky: true"></tr>
            <tr mat-header-row class="tableFilterBgColor" *matHeaderRowDef="displayColumnsFiltersDynamic; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumnsDynamic;"></tr>
            <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':loading === false}"></tr>
            <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':(dataSource!=null && resultLength != 0) || loading === true}"></tr>

        </table>
    </div>
    <mat-divider></mat-divider>
    <div class="itemsLabel">
        <div class="col-lg-9 col-sm-12">
            Items per page: <input [(ngModel)]="mattablePageSize" matInput type="text" (change)="OnPagesizeChange()">
        </div>
        <mat-paginator class="col-lg-3 col-sm-12" [pageSize]="mattablePageSize" hidePageSize="true" [length]="resultLength">
        </mat-paginator>
    </div>
</div>
